import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { setAnalyticsLanguage } from "../lib/analytics";
import enAdmin from "./locales/en/admin.json";
import enAuth from "./locales/en/auth.json";
import enCommon from "./locales/en/common.json";
import enContact from "./locales/en/contact.json";
import enGroups from "./locales/en/groups.json";
import enHome from "./locales/en/home.json";
import enItems from "./locales/en/items.json";
import enPaywall from "./locales/en/paywall.json";
import enPrivacy from "./locales/en/privacy.json";
import enSettings from "./locales/en/settings.json";
import enTemplates from "./locales/en/templates.json";
import esAdmin from "./locales/es/admin.json";
import esAuth from "./locales/es/auth.json";
import esCommon from "./locales/es/common.json";
import esContact from "./locales/es/contact.json";
import esGroups from "./locales/es/groups.json";
import esHome from "./locales/es/home.json";
import esItems from "./locales/es/items.json";
import esPaywall from "./locales/es/paywall.json";
import esPrivacy from "./locales/es/privacy.json";
import esSettings from "./locales/es/settings.json";
import esTemplates from "./locales/es/templates.json";
import itAdmin from "./locales/it/admin.json";
import itAuth from "./locales/it/auth.json";
import itCommon from "./locales/it/common.json";
import itContact from "./locales/it/contact.json";
import itGroups from "./locales/it/groups.json";
import itHome from "./locales/it/home.json";
import itItems from "./locales/it/items.json";
import itPaywall from "./locales/it/paywall.json";
import itPrivacy from "./locales/it/privacy.json";
import itSettings from "./locales/it/settings.json";
import itTemplates from "./locales/it/templates.json";
import jaAdmin from "./locales/ja/admin.json";
import jaAuth from "./locales/ja/auth.json";
import jaCommon from "./locales/ja/common.json";
import jaContact from "./locales/ja/contact.json";
import jaGroups from "./locales/ja/groups.json";
import jaHome from "./locales/ja/home.json";
import jaItems from "./locales/ja/items.json";
import jaPaywall from "./locales/ja/paywall.json";
import jaPrivacy from "./locales/ja/privacy.json";
import jaSettings from "./locales/ja/settings.json";
import jaTemplates from "./locales/ja/templates.json";
import zhAdmin from "./locales/zh/admin.json";
import zhAuth from "./locales/zh/auth.json";
import zhCommon from "./locales/zh/common.json";
import zhContact from "./locales/zh/contact.json";
import zhGroups from "./locales/zh/groups.json";
import zhHome from "./locales/zh/home.json";
import zhItems from "./locales/zh/items.json";
import zhPaywall from "./locales/zh/paywall.json";
import zhPrivacy from "./locales/zh/privacy.json";
import zhSettings from "./locales/zh/settings.json";
import zhTemplates from "./locales/zh/templates.json";

const resources = {
  ja: {
    common: jaCommon,
    home: jaHome,
    items: jaItems,
    settings: jaSettings,
    groups: jaGroups,
    auth: jaAuth,
    contact: jaContact,
    paywall: jaPaywall,
    templates: jaTemplates,
    admin: jaAdmin,
    privacy: jaPrivacy,
  },
  en: {
    common: enCommon,
    home: enHome,
    items: enItems,
    settings: enSettings,
    groups: enGroups,
    auth: enAuth,
    contact: enContact,
    paywall: enPaywall,
    templates: enTemplates,
    admin: enAdmin,
    privacy: enPrivacy,
  },
  es: {
    common: esCommon,
    home: esHome,
    items: esItems,
    settings: esSettings,
    groups: esGroups,
    auth: esAuth,
    contact: esContact,
    paywall: esPaywall,
    templates: esTemplates,
    admin: esAdmin,
    privacy: esPrivacy,
  },
  it: {
    common: itCommon,
    home: itHome,
    items: itItems,
    settings: itSettings,
    groups: itGroups,
    auth: itAuth,
    contact: itContact,
    paywall: itPaywall,
    templates: itTemplates,
    admin: itAdmin,
    privacy: itPrivacy,
  },
  zh: {
    common: zhCommon,
    home: zhHome,
    items: zhItems,
    settings: zhSettings,
    groups: zhGroups,
    auth: zhAuth,
    contact: zhContact,
    paywall: zhPaywall,
    templates: zhTemplates,
    admin: zhAdmin,
    privacy: zhPrivacy,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ja",
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "kaidoki_language",
      caches: ["localStorage"],
    },
  });

function updateDocumentMeta() {
  document.documentElement.lang = i18n.language;
  document.title = i18n.t("common:pageTitle");
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) {
    metaDesc.setAttribute("content", i18n.t("common:metaDescription"));
  }
}

i18n.on("languageChanged", () => {
  updateDocumentMeta();
  setAnalyticsLanguage(i18n.language);
});

// Set initial lang attribute and meta
updateDocumentMeta();

export default i18n;
